export enum RecurrenceEventStatus {
  Completed = 'Completed',
  Ongoing = 'Ongoing',
  Upcoming = 'Upcoming',
}
